export default __webpack_public_path__ + "static/media/icon_phs_results.c3cb92d3.svg";